import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'manager/ingredients'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  litelist (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },
  dailyFeedIntakes (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/daily-feed-intakes/`, params))
  },
  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  }
}
